import { Auth } from 'aws-amplify';
import store from '@/store';
import { getMember, postMember } from '@/api/home';

/**
 * 确保 Cognito 登录用户已同步到数据库并写入 Vuex
 * @returns {Promise<void>}
 */
export async function ensureUserInitialized() {
    try {
        const session = await Auth.currentSession();
        const idToken = session.getIdToken();
        const payload = idToken.payload;

        const userInfo = {
            sub: payload.sub,
            username: payload['cognito:username'],
            email: payload.email,
            avatarUrl: payload.picture || '',
        };

        const currentStoreUser = store.state.auth.currentUser;

        if (currentStoreUser.isAuthenticated) {
            return; // ✅ 已经认证完成，不重复处理
        }

        let member = null;
        try {
            member = await getMember(userInfo.sub);
        } catch (e) {
            console.warn("getMember失败", e.message);
        }

        if (!member) {
            const newMember = {
                sub: userInfo.sub,
                username: userInfo.username,
                email: userInfo.email,
                nickname: userInfo.email.split('@')[0],
                avatarUrl: userInfo.avatarUrl,
                createBy: userInfo.username
            };
            try {
                await postMember(newMember);
                member = await getMember(userInfo.sub); // retry
            } catch (e) {
                console.error("postMember失败", e.message);
                throw e;
            }
        }

        if (member) {
            store.commit('auth/setCurrentUser', {
                memberId: member.memberId,
                sub: member.sub,
                username: member.username,
                email: member.email,
                nickname: member.nickname,
                avatarUrl: member.avatarUrl,
                isAuthenticated: true
            });
        }
    } catch (err) {
        console.warn('用户初始化失败:', err);
        throw err; // 交由上层处理
    }
}
